/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SearchBar/view.blocks to change it.
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContent from 'DesignSystem/Popover/PopoverContent/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Trigger from './Trigger/index'



/** @type {import('Simple/types.js').View} */
export default function SearchBar({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/PatientOptions/New/ReferralSource/Content/Content/Referrals/Referral/Source/Search/SearchBar"
  
}) {
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
 onClickUseDiv={true}
>
{childProps => (
<Trigger
{...childProps}
  viewPath={`${viewPath}/Trigger`}
/>
)}
</PopoverTrigger>
<PopoverContent
{...childProps}
  viewPath={`${viewPath}/PopoverContent`}
 width="auto"
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContent>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}